@if (data) {
  <app-network-graph-v2 [data]="data" class="graph-width" [defaultView]="defaultView" [svgResize]="resize"></app-network-graph-v2>
}
